import { Fragment, useCallback, useState, useEffect } from 'react';
import { Layout, Button, message } from 'antd';
import { useLocation } from 'react-router-dom';
import RichEditor from '@components/common/RichEditor';
import { uploadFile } from '@services/Wj';
import FinalPreview from './FinalPreview';
import './index.less';
import config from '@config';
import { saveSettingApi, querySettingApi } from '@services/Wj/Question';
import { useSurveyAutosave } from '../../SurveyAutosaveContext';

const FinalCustom = () => {
    const { notifySaved } = useSurveyAutosave();
    const location = useLocation();
    const option = { headers: { 'Content-Type': 'multipart/form-data' } };
    const [finalValue, setFinalValue] = useState(undefined);
    const [preview, setPreview] = useState(false);

    const getFileUrl = url => {
        if (url && url.includes('https')) {
            return url;
        }
        if (url && !url.includes('https')) {
            return config.OSS_PREFIX + `/${url}`;
        }
        return null;
    };

    const imageUploadHandler = useCallback(async blobInfo => {
        const formData = new FormData();
        formData.append('file', blobInfo.blob());
        formData.append('path', `skins/upload/`);
        const hide = message.loading('上传中...', 0);
        try {
            const res = await uploadFile(formData, option);
            const url = getFileUrl(res.data);
            hide();
            return url;
        } catch (e) {
            hide();
            throw e;
        }
    }, []);

    const fnalChange = v => {
        setFinalValue(v);
    };

    const closeFinalPreview = () => {
        setPreview(false);
    };

    const onSave = () => {
        if (location.state.route === 'newCreate') {
            saveSettingApi({ endPage: finalValue, surveyId: location.state.id, type: 1 }).then(res => {
                if (res.status_code === 200) {
                    notifySaved();
                }
            });
        } else if (location.state.route === 'newList' || location.state?.route === 'newTemplate') {
            saveSettingApi({ endPage: finalValue, surveyId: location.state.id, type: 2 }).then(res => {
                if (res.status_code === 200) {
                    notifySaved();
                }
            });
        }
    };

    const onPreview = () => {
        if (location.state.route === 'newCreate') {
            saveSettingApi({ endPage: finalValue, surveyId: location.state.id, type: 1 }).then(res => {
                if (res.status_code === 200) {
                    setPreview(true);
                }
            });
        } else if (location.state.route === 'newList' || location.state?.route === 'newTemplate') {
            saveSettingApi({ endPage: finalValue, surveyId: location.state.id, type: 2 }).then(res => {
                if (res.status_code === 200) {
                    setPreview(true);
                }
            });
        }
    };

    useEffect(() => {
        querySettingApi({ id: location.state.id, type: location.state.route === 'newCreate' ? 1 : 2 }).then(res => {
            if (res.status_code === 200) {
                setFinalValue(res.data.endPage);
            }
        });
    }, []);
    return (
        <Fragment>
            <div className="page-route-body">
                <div className="main-content-body">
                    <div className="table-caption">
                        <div className="setting-title">
                            <div className="finalcustom-head">
                                <div style={{ cursor: 'pointer' }} className="finalcustom-goback" onClick={() => window.history.back()}>
                                    <i className="bi bi-chevron-left"></i>
                                    返回
                                </div>
                                <div style={{ cursor: 'pointer' }}>
                                    <Button type="primary" style={{ marginRight: 10 }} onClick={onSave}>
                                        保存
                                    </Button>
                                    <Button icon={<i className="bi bi-eye"></i>} type="primary" ghost onClick={onPreview}>
                                        预览
                                    </Button>
                                </div>
                            </div>
                            <div className="finalcustom-editorbox">
                                <RichEditor id="wj-final-custom-endpage" mode="full" value={finalValue} onChange={fnalChange} imageUploadHandler={imageUploadHandler} toolbar="bold underline forecolor image" plugins="autolink advlist lists image" className="finalcustom-editor" height={400} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <FinalPreview preview={preview} closeFinalPreview={closeFinalPreview} />
        </Fragment>
    );
};

export default FinalCustom;
